import { useState } from "react";
import { fr } from "date-fns/locale";
import { format, parseISO, isValid } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const toIso = (d) => (d ? format(d, "yyyy-MM-dd") : "");

/** Remplacement de <Input type="date"> : même contrat (value "yyyy-MM-dd", onChange({ target: { value } })), affichage français. */
export function DateInput({ value, onChange, className, placeholder = "jj/mm/aaaa", disabled, min, max, required, name, years = false, ...rest }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : null;
  const ok = date && isValid(date);
  const emit = (v) => onChange?.({ target: { value: v, name } });
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} {...rest} onTouchEnd={(e) => { if (!disabled && !open) { e.preventDefault(); setOpen(true); } }}
          className={cn("flex h-10 min-h-[40px] w-full items-center gap-2 rounded-md border border-slate-200 bg-white px-3 text-sm text-left touch-manipulation focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50", ok ? "text-slate-900" : "text-slate-400", className)}>
          <CalendarIcon className="w-4 h-4 text-slate-400 shrink-0" />
          <span className="flex-1 truncate">{ok ? format(date, "dd/MM/yyyy") : placeholder}</span>
          {ok && !required && <span role="button" aria-label="Effacer" onClick={(e) => { e.stopPropagation(); emit(""); }} onTouchEnd={(e) => { e.stopPropagation(); e.preventDefault(); emit(""); }} className="text-slate-400 hover:text-slate-700 px-2 py-1 -mr-1">×</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[100]" align="start" onOpenAutoFocus={(e) => e.preventDefault()}>
        <Calendar mode="single" locale={fr} weekStartsOn={1} {...(years ? { captionLayout: "dropdown-buttons", fromYear: 1920, toYear: new Date().getFullYear() + 5 } : {})} selected={ok ? date : undefined} defaultMonth={ok ? date : undefined}
          disabled={(d) => (min && toIso(d) < min) || (max && toIso(d) > max)}
          onSelect={(d) => { emit(toIso(d)); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
